import { useSetRecoilState } from "recoil";
import useReselectDoc from "../useReselectDoc";
import { analysisFormStepState } from "store/document/analysisDocument";

const useReselectAnalysisDoc = ({
  tempDocumentUuid,
}: {
  tempDocumentUuid?: string;
}) => {
  const setAnalysisFormStep = useSetRecoilState(analysisFormStepState);

  const { onClickReselect } = useReselectDoc();

  const onClickReselectAnalysisDoc = () =>
    onClickReselect({
      uuid: tempDocumentUuid,
      callback: () => {
        setAnalysisFormStep(0);
      },
    });

  return {
    onClickReselectAnalysisDoc,
  };
};

export default useReselectAnalysisDoc;
